import styles from "./About.module.css";

const PROCESS_STEPS = [
  {
    step: "01",
    title: "Ingeniería & Diseño CAD/CAE",
    body: "Levantamiento de requerimientos, dimensionamiento mecánico, selección de componentes y validación en entorno virtual antes de fabricar.",
  },
  {
    step: "02",
    title: "Fabricación & Electrónica",
    body: "Manufactura mecánica, ensamble estructural, diseño de tarjetas electrónicas e integración de tableros de potencia y control.",
  },
  {
    step: "03",
    title: "Instrumentación & Control",
    body: "Programación de PLC/HMI, telemetría IoT, calibración de sensores y pruebas de esfuerzo en condiciones reales de operación.",
  },
  {
    step: "04",
    title: "Puesta en marcha & Trazabilidad",
    body: "Comisionamiento en planta o laboratorio, capacitación operativa y entrega de dossier técnico completo (planos, manuales y certificados).",
  },
];

export default function About() {
  return (
    <section id="nosotros" className={styles.wrap}>
      <div className={styles.top}>
        <div>
          <span className="mono-tag">// 04 — Nosotros</span>

          <h2 className={styles.h2}>
            Un taller-laboratorio<br />
            <span className={styles.alt}>donde la idea</span><br />
            <span className={styles.underline}>se vuelve máquina</span>.
          </h2>

          <p className={styles.lead}>
            Aya Technologies reúne diseño mecánico, electrónica, software y
            datos en un mismo equipo. Trabajamos para laboratorios académicos,
            centros de investigación e industrias que necesitan equipos
            específicos, integrados y trazables.
          </p>
        </div>

        <dl className={styles.stats}>
          <div className={styles.statCard}>
            <dt>+12</dt>
            <dd>equipos diseñados y entregados a medida</dd>
          </div>
          <div className={styles.statCard}>
            <dt>8</dt>
            <dd>frentes técnicos integrados bajo un mismo techo</dd>
          </div>
          <div className={styles.statCard}>
            <dt>100%</dt>
            <dd>de proyectos con documentación y trazabilidad técnica</dd>
          </div>
        </dl>
      </div>

      <div className={styles.methodWrap}>
        <header className={styles.methodHead}>
          <span className="mono-tag">↳ metodología de trabajo</span>
          <h3 className={styles.methodTitle}>
            De la especificación al <span className={styles.alt}>equipo en marcha</span>.
          </h3>
        </header>

        <ol className={styles.methodGrid}>
          {PROCESS_STEPS.map((item) => (
            <li key={item.step} className={styles.methodCard}>
              <span className={styles.stepNum}>// etapa {item.step}</span>
              <h4 className={styles.stepTitle}>{item.title}</h4>
              <p className={styles.stepBody}>{item.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
